import Add from "@mui/icons-material/Add";
import Business from "@mui/icons-material/Business";
import LoginOutlined from "@mui/icons-material/LoginOutlined";
import { colors } from "healthex-common/colors";
import { DocumentRetrievalLocationStatus } from "healthex-common/document.retrieval.dtos";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { FlexColumn, FlexColumnDiv, FlexRowDiv } from "./common.styles";
export const LocationContainer = styled(FlexColumnDiv) `
    margin: 16px 0;
    padding: 16px;
    border-radius: 4px;
    gap: 4px;
`;
export const LocationCard = styled(FlexColumnDiv) `
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    gap: 16px;
    padding: 16px;
    align-self: stretch;
    background-color: ${(props) => props.status === DocumentRetrievalLocationStatus.COMPLETE ||
    props.status === DocumentRetrievalLocationStatus.ERROR ||
    props.status === DocumentRetrievalLocationStatus.IN_PROGRESS
    ? colors.forest_8
    : props.status === DocumentRetrievalLocationStatus.SKIPPED
        ? colors.black_4
        : undefined};
`;
export const AddAnotherCard = styled(FlexColumnDiv) `
    border-radius: 4px;
    border: 1px dashed ${colors.navy_main};
    gap: 16px;
    padding: 16px;
    align-self: stretch;

    & fasten-stitch-element > button {
        width: 100% !important;
        border: 1px solid ${colors.navy_50} !important;
        background-color: ${colors.white_main} !important;
        border-radius: 4px !important;
        font-size: ${fontSizes.STANDARD} !important;
        font-weight: 590 !important;
        color: ${colors.navy_main} !important;
        padding: 8px 32px;
        height: 56px;
    }
`;
export const LocationHeader = styled(FlexRowDiv) `
    align-self: stretch;
    width: 100%;
    gap: 8px;
`;
export const LocationLogo = styled.img `
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    width: 80px;
    height: 80px;
    justify-content: center;
    align-items: center;
    object-fit: contain;
    background-color: ${colors.white_main};
`;
export const BusinessIcon = styled(Business) `
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    width: 80px;
    height: 80px;
    justify-content: center;
    align-items: center;
    object-fit: contain;
    color: ${colors.black_lighter};
    background-color: ${colors.white_main};
`;
export const LocationTextContainer = styled(FlexColumnDiv) `
    align-self: center;
    gap: 4px;
`;
export const LocationName = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: 590;
    text-align: left;
    line-height: normal;
    color: ${(props) => (props.status === DocumentRetrievalLocationStatus.SKIPPED ? colors.black_30 : colors.black_main)};
    overflow-wrap: anywhere;
`;
export const AddAnotherTitle = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: 590;
    text-align: center;
    line-height: normal;
    color: ${colors.black_main};
`;
export const FastenLabel = styled(FlexRowDiv) `
    align-self: stretch;
    align-items: center;
    justify-content: ${(props) => { var _a; return (_a = props.justifyContent) !== null && _a !== void 0 ? _a : "center"; }};
    cursor: pointer;
    width: 100%;
    gap: 8px;
`;
export const FastenLabelText = styled(FlexColumn) `
    font-size: ${fontSizes.STANDARD};
    font-weight: 590;
    text-align: center;
    line-height: normal;
    color: ${colors.black_main};
`;
export const FastenSecondaryLabel = styled(FlexRowDiv) `
    align-items: center;
    justify-content: ${(props) => { var _a; return (_a = props.justifyContent) !== null && _a !== void 0 ? _a : "center"; }};
    width: 100%;
    height: 56px;
    padding: 0 16px;
    gap: 8px;
    border-radius: 999px;
    background-color: ${colors.navy_main};
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    box-sizing: border-box;

    /* &:hover {
        background-color: ${colors.navy_4};
    } */

    /* &:active {
        background-color: ${colors.navy_8};
    } */

    svg {
        color: ${colors.navy_main} !important;
        fill: ${colors.navy_main} !important;
    }
`;
export const FastenSecondaryLabelInCard = styled(FlexRowDiv) `
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    padding: 0 16px;
    gap: 8px;
    border: none;
    border-radius: 0;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    box-sizing: border-box;
    pointer-events: auto;

    /* Ensure icons and text are visible */
    svg,
    span,
    div {
        pointer-events: auto;
        color: ${colors.navy_main};
        fill: ${colors.navy_main};
    }
`;
export const FastenWrapper = styled(FlexColumnDiv) `
    width: 100%;
    align-items: center;

    & fasten-stitch-element {
        display: block;
        width: 100%;
        outline: none;
        border: none;

        &:focus,
        &:focus-visible,
        &:active {
            outline: none !important;
            border: none !important;
            box-shadow: none !important;
        }
    }

    & fasten-stitch-element > button {
        width: 100% !important;
        border: none !important;
        background-color: transparent !important;
        border-radius: 4px !important;
        font-size: ${fontSizes.STANDARD} !important;
        font-weight: 590 !important;
        color: ${colors.navy_main} !important;
        padding: 0px;
        height: 56px;
        outline: none !important;
        box-shadow: none !important;

        &:focus,
        &:focus-visible {
            outline: none !important;
            border: none !important;
            box-shadow: none !important;
        }

        &:active {
            outline: none !important;
            border: none !important;
            box-shadow: none !important;
        }
    }
`;
export const FastenSecondaryLabelText = styled.div `
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    line-height: 1.75;
    color: white;
    text-transform: none;
    letter-spacing: 0.02857em;
`;
export const LocationActions = styled(FlexColumnDiv) `
    align-items: center;
    width: 100%;
    gap: 4px;
`;
export const IncludeRecordsText = styled.div `
    text-align: center;
    height: 40px;
    color: ${colors.black_light};
`;
export const LocationErrorText = styled.div `
    text-align: left;
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    color: ${colors.tulip_main};
`;
export const LoginIcon = styled(LoginOutlined) `
    width: 16.67px;
    height: 16.67px;
`;
export const AddIcon = styled(Add) `
    width: 16.67px;
    height: 16.67px;
    color: ${colors.navy_main};
`;
export const LocationStatusContainer = styled(FlexRowDiv) `
    align-self: stretch;
    width: 100%;
    gap: 4px;
`;
export const LocationStatusText = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: 400;
    text-align: left;
    line-height: normal;
    color: ${(props) => props.status === DocumentRetrievalLocationStatus.COMPLETE ||
    props.status === DocumentRetrievalLocationStatus.ERROR ||
    props.status === DocumentRetrievalLocationStatus.IN_PROGRESS
    ? colors.forest_main
    : props.status === DocumentRetrievalLocationStatus.SKIPPED
        ? colors.black_12
        : colors.black_lighter};
`;
export const LocationContent = styled(FlexColumnDiv) `
    align-items: center;
    justify-content: center;
    justify-items: center;
    min-height: 40px;
    margin: 0px;
    padding: 10px 0px;
    gap: 10px;
`;
export const NoRecordsCard = styled(FlexColumnDiv) `
    border-radius: 4px;
    background-color: ${colors.sunset_8};
    gap: 24px;
    padding: 16px;

    & fasten-stitch-element > button {
        width: 100% !important;
        border: 1px solid ${colors.navy_50} !important;
        background-color: ${colors.white_main} !important;
        border-radius: 999px !important;
        font-size: ${fontSizes.STANDARD} !important;
        font-weight: 590 !important;
        color: ${colors.navy_main} !important;
        padding: 8px 32px;
        height: 56px;
    }
`;
